export default {
  Slider: {
    parts: ['container', 'thumb', 'track', 'filledTrack'],
    baseStyle: {},
    sizes: {},
    variants: {},
    defaultProps: {},
  },
};
